import React, { ReactElement } from 'react';
import { Collapse, Row } from 'antd';
import { ReactComponent as ExpandIcon } from '../../../../src/assets/images/svg/plus-large_svgrepo.svg';
import { ReactComponent as MinusIcon } from '../../../../src/assets/images/svg/mimimize_icon.svg';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { NHCXState } from '../../../store/models/nhcxModel';
import { NOTREQUIRED, POLICY_NOTE } from '../../constants/commonConstants';
import { PayerInitialState } from '../../../store/models/payerListModel';

const IPODetailsGuide = (): ReactElement => {
  const { Panel } = Collapse;
  const { ipoResponse } = useSelector((state: RootState): NHCXState => state.nhcx);
  const { payer: { shortName } } = useSelector((state: RootState): PayerInitialState => state.payerList);

  interface CoverageData {
    [key: string]: string[];
  }

  let ipoCoverageData: CoverageData = {};
  const coverage = ipoResponse?.coverage;
  if (coverage && typeof coverage === 'object' && !Array.isArray(coverage)) {
    ipoCoverageData = Object?.entries(coverage)?.reduce((acc: any, [key, value]: any): any => {
      acc[key] = value;
      return acc;
    }, {} as CoverageData);
  }
    const coverageDetails = Object?.keys(ipoCoverageData);

  return<>
    <Collapse className="mt-sm" expandIconPosition="right"
      // tslint:disable-next-line: typedef
      expandIcon={({ isActive }) => isActive ? <MinusIcon /> : <ExpandIcon />} defaultActiveKey={['1']}>
      <Panel header={<span className="policy-header">Policy Exclusions</span>} key="IPO" className="policy-header">
        <Row>
          <div className="list-scroll">
            {<ul className="listed-items">
              {ipoResponse?.exclusionsOfPolicy?.map((ele: any): any => {
                return <li key={ele}>
                  {ele}
                </li>;
              })}
            </ul>
            }
          </div>
        </Row>
        <p className="policy-note">{'Policy Condition'} : {ipoResponse?.claimCondition || '-'}</p>
      </Panel>
    </Collapse>
    <Collapse className="mt-sm" expandIconPosition="right"
      // tslint:disable-next-line: typedef
      expandIcon={({ isActive }) => isActive ? <MinusIcon /> : <ExpandIcon />} defaultActiveKey={['1']}>
      <Panel header={<span className="policy-header">Policy Coverage</span>} key="IPO" className="policy-header">
        <Row>
          <div className="coverage-items">
            {coverageDetails?.length > 0 ? (
              <ul className="base-policy">
                {coverageDetails?.map((key: any): any => (
                  <li key={key} className="bold">
                    {key}
                    <ul className="ulStyle">
                      {ipoCoverageData?.[key]?.map((item: any, index: any): any => {
                        return <li className="sub-items" key={index}>{item}</li>;
                      })}
                    </ul>
                  </li>
                ))}
              </ul>
            ) : (
              <ul>
                <li> {NOTREQUIRED}</li>
              </ul>
            )}
          </div>
        </Row>
        <p className="policy-note">{POLICY_NOTE?.[shortName] || '-'}</p>
      </Panel>
    </Collapse>
    <Collapse className="mt-sm" expandIconPosition="right"
      expandIcon={({ isActive }: any): any => isActive ? <MinusIcon /> : <ExpandIcon />} defaultActiveKey={['1']}>
      <Panel header={<span className="policy-header">Policy Sublimits</span>} key="IPO" className="policy-header">
        <Row>
          <div className="policy-sublimits">
            {ipoResponse?.['sublimits'] ?
              <ul>
                {ipoResponse?.['sublimits']?.map((ele: any): any => {
                  return <li key={ele}>
                    {ele}
                  </li>;
                })}
              </ul> : <ul>
                <li> {NOTREQUIRED}</li>
              </ul>
            }
          </div>
        </Row>
      </Panel>
    </Collapse>
  </>;
};
export default IPODetailsGuide;
